import React from 'react';
import styled from 'styled-components';

import ChevronDownIcon from '@ad-scripts/presentation/components/common/icons/stroke/chevron-down-stroke';
import ChevronUpIcon from '@ad-scripts/presentation/components/common/icons/stroke/chevron-up-stroke';
import { InternalLink } from 'src/presentation/components/pages/shared/Links';

export const LinkToIvr = ({
  id,
  version,
  name,
  nodeId,
  nameFn = (name, version) => (name ? `${name}, v.${version}` : ''),
}: {
  id: string;
  version: number;
  name: string;
  nodeId?: string;
  nameFn?: Function;
}) => {
  const url = `/ivrs/${id}#version=${version}${nodeId ? `&nodeId=${nodeId}` : ''}`;
  return (
    <InternalLink target="_blank" to={url}>
      {nameFn(name, version, nodeId)}
    </InternalLink>
  );
};

export const StyledChevronUpIcon = styled(ChevronUpIcon)`
  width: 16px;
  height: 16px;
`;

export const StyledChevronDownIcon = styled(ChevronDownIcon)`
  width: 16px;
  height: 16px;
`;
